import React from 'react';
import BulletinActions from './BulletinActions';

const BulletinTableRow = ({ 
  bulletin, 
  onVoirBulletin, 
  onDownload, 
  onPrint, 
  onEmail 
}) => {
  const getStatusColor = (status) => {
    return status ? 'bg-green-100 text-green-800 border-green-200' : 'bg-yellow-100 text-yellow-800 border-yellow-200';
  };

  const getStatusText = (status) => {
    return status ? 'Validé' : 'En attente';
  };

  return (
    <tr className="hover:bg-gray-50 transition-colors">
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="flex-shrink-0 h-10 w-10">
            {bulletin.etudiant?.photo ? (
              <img
                className="h-10 w-10 rounded-full object-cover"
                src={bulletin.etudiant.photo}
                alt={`${bulletin.etudiant.nom} ${bulletin.etudiant.prenom}`}
              />
            ) : (
              <div className="h-10 w-10 rounded-full bg-[#202654] flex items-center justify-center">
                <span className="text-white font-medium text-sm">
                  {bulletin.etudiant?.nom?.charAt(0) || '?'}
                </span>
              </div>
            )}
          </div>
          <div className="ml-4">
            <div className="text-sm font-medium text-gray-900">
              {bulletin.etudiant?.nom} {bulletin.etudiant?.prenom}
            </div>
            <div className="text-sm text-gray-500">
              {bulletin.etudiant?.email || 'Aucun email'}
            </div>
          </div>
        </div>
      </td>
      
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {bulletin.etudiant?.matricule || 'N/A'}
      </td>
      
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-900">
          {bulletin.moyenne_semestre?.moyenne_generale || 'N/A'}/20
        </div>
        {bulletin.moyenne_semestre?.mention_semestre && (
          <div className="text-xs text-gray-500">
            {bulletin.moyenne_semestre.mention_semestre}
          </div>
        )}
      </td>
      
      <td className="px-6 py-4 whitespace-nowrap">
        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full border ${getStatusColor(bulletin.est_valide)}`}>
          {getStatusText(bulletin.est_valide)}
        </span>
      </td>
      
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        S{bulletin.semestre?.numero} - {bulletin.semestre?.libelle}
      </td>
      
      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
        <BulletinActions
          bulletinId={bulletin.id}
          onVoir={onVoirBulletin}
          onDownload={onDownload}
          onPrint={onPrint}
          onEmail={onEmail}
        />
      </td>
    </tr>
  );
};

export default BulletinTableRow;